import * as React from 'react';
import { useState } from 'react';
import { Browser } from '@capacitor/browser';
import useAppVersionCheck from '../core/api/appVersionCheck';
import Loading from './Loading';
import BottomModal from './bottomModal/BottomModal';
import { isWebApp } from '../lib/utils';

const AppVersionGate = ({ children }: Props) => {
	const [bannerDismissed, setBannerDismissed] = useState(false);
	const data = useAppVersionCheck();

	const openStore = async () => {
		if (data?.storeUrl) await Browser.open({ url: data.storeUrl });
	};

	if (isWebApp) return children;

	if (data === undefined) return <Loading />;

	if (!data || data.status === 'ok') return children;

	if (data.status === 'force-update' || data.status === 'soft-update') {
		const isSoftUpdate = data.status === 'soft-update';
		return (
			<>
				<BottomModal
					open={!bannerDismissed}
					onClose={isSoftUpdate ? () => setBannerDismissed(true) : undefined}
					title={isSoftUpdate ? 'Update Available' : 'Update the app to continue'}
					body={[data.message]}
					actions={[
						{ label: 'Update Now', callback: openStore },
						...(isSoftUpdate ? [{ label: 'Later', callback: () => {} }] : [])
					]}
				/>
				{children}
			</>
		);
	}

	return children;
};

export default AppVersionGate;

interface Props {
	children: React.ReactNode;
}
